/** Parser for credit card value
 * Passed in "1234 5678 1234 5678" will be transformed into a "1234567812345678"
 * Tip: some credit cards can be from 13 up to 19 numbers
 * @param {string} value  Parsed value
 * @param {Object} obj
 * @param {number} obj.max  Maximum amount of numbers
 */
const creditCardNumberParser = (
  value: string,
  { max }: { max: number } = { max: 16 },
): string => value.replace(/\D+/g, "").substring(0, max);

export default creditCardNumberParser;
